import { effects } from 'redux-saga'

import { constants as auth } from '../../modules/authentication'
import { FINISH_LOADING, UPDATE_ACTIVITY } from '../../modules/meta'

import initSaga from './init'
import login from './login'
import logout from './logout'
import parse from './parse'
import refresh from './refresh'
import requiresAuth from './requiresAuth'
import timeout from './timeout'
import update from './update'

export default function* authenticate(
  { sso, invocation },
  {
    getHref,
    init = true,
    sessionTimeout,
    setHref,
  },
) {
  if (init) {
    yield effects.fork(initSaga, FINISH_LOADING)
  }

  yield [
    effects.takeEvery(auth.HANDLE_LOGIN, parse, sso.getRedirectUrl(), getHref, setHref),
    effects.takeEvery(auth.LOGIN, login, sso.getUser),
    effects.takeEvery(auth.LOGOUT, logout, sso, setHref),
    effects.takeEvery(auth.REFRESH_CREDENTIALS, refresh, invocation),
    effects.takeEvery(auth.REQUIRES_AUTHENTICATION, requiresAuth),
    effects.takeLatest(auth.RECEIVE_CREDENTIALS, update),
    effects.takeLatest(UPDATE_ACTIVITY, timeout, sessionTimeout),
  ]
}

export const sagas = {
  init: initSaga,
  login,
  logout,
  parse,
  refresh,
  requiresAuth,
  timeout,
  update,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/authentication/index.js